import http from '@/common/request/axios';

export const arenaService = {
    setting: {
        get() {
            return http.doGet('/admin/arena/setting');
        },
        update(levelTimeout: any, groupTimeout: any, findingMatchTimeout: any) {
            return http.doPut('/admin/arena/setting', {
                levelTimeout: levelTimeout,
                groupTimeout: groupTimeout,
                findingMatchTimeout: findingMatchTimeout
            });
        },
        remove() {
            return http.doDelete('/admin/arena/setting');
        }
    },

    item: {
        create(
            cloneId: any,
            name: any,
            matchId: any,
            maxRejection: any,
            price: any,
            jackpotInit: any,
            jackpotWinPercent: any,
            jackpotDonation: any,
            prizes: any,
            ticketType: any,
            timeUnit: any,
            timeDuration: any,
            publishSeconds: any,
            startSeconds: any,
            closeSeconds: any,
            endSeconds: any,
            publishTime: any,
            unpublishTime: any
        ) {
            return http.doPost('admin/arena/item', {
                cloneId,
                name,
                matchId,
                maxRejection,
                price,
                jackpotInit,
                jackpotWinPercent,
                jackpotDonation,
                prizes,
                ticketType,
                timeUnit,
                timeDuration,
                publishSeconds,
                startSeconds,
                closeSeconds,
                endSeconds,
                publishTime,
                unpublishTime
            });
        },

        update(
            id: any,
            name: any,
            publishSeconds: any,
            startSeconds: any,
            closeSeconds: any,
            endSeconds: any,
            unpublishTime: any
        ) {
            return http.doPost('admin/arena/item/' + id, {
                name,
                publishSeconds,
                startSeconds,
                closeSeconds,
                endSeconds,
                unpublishTime
            });
        },

        enable(id: any) {
            return http.doPut('admin/arena/item/' + id + '/enable');
        },

        disable(id: any) {
            return http.doPut('admin/arena/item/' + id + '/disable');
        },

        archive(id: any) {
            return http.doPut('admin/arena/item/' + id + '/archive');
        },

        remove(id: any) {
            return http.doDelete('admin/arena/item/' + id);
        },

        get(id: any) {
            return http.doGet('admin/arena/item/' + id);
        },

        list({ offset, limit }: any) {
            return http.doGet('admin/arena/item', { offset, limit });
        },

        getList(itemIds: any) {
            return http.doGet('admin/arena/item/status', {
                itemIds: itemIds
            });
        }
    },

    cycle: {
        list({ offset, limit }: any) {
            return http.doGet('admin/arena/cycle', { offset, limit });
        }
    },

    medal: {
        getLinked({ arenaId }: any) {
            return http.doGet('admin/arena/' + arenaId + '/medal');
        },

        link(arenaId: any, medalIds: any) {
            return http.doPut('admin/arena/' + arenaId + '/medal/link', {
                medalIds: medalIds
            });
        },

        unlink(arenaId: any, medalIds: any) {
            return http.doPut('admin/arena/' + arenaId + '/medal/unlink', {
                medalIds: medalIds
            });
        },

        create(name: any, rank: any, image: any) {
            return http.doPost(
                'admin/arena/medal',
                {
                    name: name,
                    rank: rank
                },
                {
                    image: image
                }
            );
        },

        update(id: any, name: any, rank: any, image: any) {
            return http.doPost(
                'admin/arena/medal/' + id,
                {
                    name: name,
                    rank: rank
                },
                {
                    image: image
                }
            );
        },

        remove(id: any) {
            return http.doDelete('admin/arena/medal/' + id);
        },

        get(id: any) {
            return http.doGet('admin/arena/medal/' + id);
        },

        list() {
            return http.doGet('admin/arena/medal');
        }
    },

    rank: {
        list({ offset, limit, arenaId, cycleId, accountId, sortOrder }: any) {
            return http.doGet('admin/arena/rank/' + arenaId, { offset, limit, cycleId, accountId, sortOrder });
        }
    },

    ticket: {
        update(type: any, name: any) {
            return http.doPut('admin/arena/ticket', {
                type: type,
                name: name
            });
        },

        get(type: any) {
            return http.doGet('admin/arena/ticket/' + type);
        },

        list() {
            return http.doGet('admin/arena/ticket');
        },

        remove(type: any) {
            return http.doDelete('admin/arena/ticket/' + type);
        }
    }
};
